import { toast, ToastOptions } from "react-toastify";
const baseOptions: ToastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
};

export const Toast = {
  success: (message: string) =>
    toast.success(message, baseOptions),

  error: (message: string) =>
    toast.error(message, baseOptions),

  warning: (message: string) =>
    toast.warning(message, baseOptions),

  info: (message: string) =>
    toast.info(message, baseOptions)
};
